import { render, staticRenderFns } from "./TargetIndustry.vue?vue&type=template&id=2b3e469b"
import script from "./TargetIndustry.vue?vue&type=script&lang=js"
export * from "./TargetIndustry.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports